/* istanbul ignore file */
import React from 'react';
import { getExperiments } from '@noths/polaris-client-experiments';
import { BaseApp, BaseAppProps } from '@noths/polaris-client-next-components';
import NextApp, { AppContext, AppInitialProps, AppProps } from 'next/app';
import getConfig from 'next/config';
import Head from 'next/head';

import { PreviewMode } from 'src/components/molecules/PreviewMode';
import { APP_STORE_ID } from 'src/constants/pageAttributes';

const config = getConfig();
const AppComponent = BaseApp(config);

const App = (props: AppProps & BaseAppProps) => {
  const {
    pageProps: { isPreview, topBannerData },
  } = props;

  return (
    <>
      <Head>
        <meta name="apple-itunes-app" content={`app-id=${APP_STORE_ID}`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="shortcut icon" href={`${config.publicRuntimeConfig.CDN_URL}/favicon.ico`} />
      </Head>
      {isPreview && <PreviewMode />}
      <AppComponent {...props} topBannerData={topBannerData} />
    </>
  );
};

App.getInitialProps = async (appContext: AppContext): Promise<AppInitialProps & BaseAppProps> => {
  const {
    ctx: { req },
  } = appContext;
  const experiments = (req && getExperiments(req)) ?? '';
  const appProps = await NextApp.getInitialProps(appContext);

  return { ...appProps, experiments };
};

export default App;
